var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 0.5H1.75003C1.3522 0.5 0.970671 0.658035 0.689367 0.93934C0.408062 1.22064 0.250027 1.60218 0.250027 2V17C0.248297 17.286 0.329215 17.5665 0.483052 17.8076C0.63689 18.0488 0.857101 18.2404 1.11721 18.3594C1.31543 18.4517 1.53138 18.4997 1.75003 18.5C2.10216 18.4992 2.4426 18.3736 2.71096 18.1456C2.71544 18.1427 2.71953 18.1392 2.72315 18.1353L5.7344 15.5H18.25C18.6479 15.5 19.0294 15.342 19.3107 15.0607C19.592 14.7794 19.75 14.3978 19.75 14V2C19.75 1.60218 19.592 1.22064 19.3107 0.93934C19.0294 0.658035 18.6479 0.5 18.25 0.5ZM18.25 14H5.7344C5.38117 13.9998 5.03922 14.1243 4.76878 14.3516L4.75753 14.3619L1.75003 17V2H18.25V14Z",
    fill: "#A1A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageVector);
export default __webpack_public_path__ + "static/media/Message-vector.d727beadc4b75154b0c1f216348fa635.svg";
export { ForwardRef as ReactComponent };